module.exports = __webpack_public_path__ + "img/status1.79f93a08.png";